import gql from 'graphql-tag'

export const SEND_EVENT = gql`
    mutation sendEvent($event: EventInput!) {
        sendEvent(event: $event) {
            event_type
            experiments_info {
                experiment_id
                experiment_variant
            }
            ga_attributes {
                action
                category
                label
                value
            }
            ids {
                event_id
                mouse_position
                pageview_id
                session_id
                user_id
            }
            timestamp
            unique_info {
                key
                value
            }
            version
        }
    }
`
